import styled from 'styled-components';

export const GridPopoverOpener = styled.div`
  cursor: pointer;
  width: max-content;
`;

export const GridHeader = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const GridContainer = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: ${({ columns = 6 }) => `repeat(${columns}, 1fr)`};
  gap: ${({ theme }) => theme.spacing(0.5)}px;
`;
